import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/*eslint-disable*/
import request from '@/utils/request';
export function addArea(data) {
  return request({
    url: 'api/resourceArea/add',
    method: 'post',
    data: data
  });
}
export function add(data) {
  return request({
    url: 'api/base/csBaseResources',
    method: 'post',
    data: data
  });
}
export function del(ids) {
  return request({
    url: 'api/base/csBaseResources',
    method: 'delete',
    data: ids
  });
}
export function edit(data) {
  return request({
    url: 'api/base/csBaseResources',
    method: 'put',
    data: data
  });
}

/**
 * 获取资源详情
 * tips: 资源详情包含 code、address 等字段，请谨慎赋值！！！
 *
 * @param id {string} 资源ID
 * @return {Promise<{id: string, areaId: string address: string}|*>}
 */
export function detail(_x) {
  return _detail.apply(this, arguments);
}

/**
 * 启用/禁用
 *
 * @param data {Object<{ ids: string[], status: number }>}
 */
function _detail() {
  _detail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (id) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", {});
        case 2:
          _context.prev = 2;
          _context.next = 5;
          return request({
            url: 'api/base/csBaseResources/detail',
            method: 'get',
            params: {
              id: id
            }
          });
        case 5:
          return _context.abrupt("return", _context.sent);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", {});
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _detail.apply(this, arguments);
}
export function switchStatus(data) {
  return request({
    url: 'api/base/csBaseResources/status',
    method: 'put',
    data: data
  });
}

/**
 * 导入房间数据
 *
 * @param data {Object<{ file }>}
 */
export function uploadRoom(data) {
  return request({
    url: 'api/base/csBaseResources/upload-room',
    method: 'post',
    'Content-Type': 'multipart/form-data',
    data: data
  });
}

/**
 * 获取资源区域列表
 *
 * @param params {Object<{ companyId: string, areaId: string, areaName: string }>}
 */
export function loadAreaDict() {
  return _loadAreaDict.apply(this, arguments);
}

/**
 * 获取楼宇字典列表
 *
 * @param params {Object<{ areaId: string, buildingType: string }>}
 * @return {Promise<Array|any[] | (*|{label: null, value})[]>}
 */
function _loadAreaDict() {
  _loadAreaDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var params,
      data,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _context2.prev = 1;
          _context2.next = 4;
          return request({
            url: 'api/base/csBaseResources/fetch-my-area',
            method: 'get',
            params: params
          });
        case 4:
          data = _context2.sent;
          return _context2.abrupt("return", (data || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              value: item.areaId,
              label: item.areaName
            });
          }));
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);
          return _context2.abrupt("return", []);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _loadAreaDict.apply(this, arguments);
}
export function loadBuildingDict() {
  return _loadBuildingDict.apply(this, arguments);
}

/**
 * 获取楼层字典列表
 *
 * @param params {Object<{ areaId: string, buildingId: string }>}
 * @return {Promise<any[] | (*|{label: null, value: *})[]|Array>}
 */
function _loadBuildingDict() {
  _loadBuildingDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var params,
      data,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          params = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _context3.prev = 1;
          _context3.next = 4;
          return request({
            url: 'api/base/csBaseResources/fetch-building',
            method: 'get',
            params: params
          });
        case 4:
          data = _context3.sent;
          return _context3.abrupt("return", (data || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              value: item.buildingId,
              label: item.buildingName
            });
          }));
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](1);
          return _context3.abrupt("return", []);
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 8]]);
  }));
  return _loadBuildingDict.apply(this, arguments);
}
export function loadFloorDict() {
  return _loadFloorDict.apply(this, arguments);
}

/**
 * 获取房间字典列表
 *
 * @param params {Object<{ areaId: string, buildingId: string, floorId: string }>}
 * @return {Promise<Array|any[] | (*|{label: string, value: null})[]>}
 */
function _loadFloorDict() {
  _loadFloorDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var params,
      data,
      _args4 = arguments;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          params = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _context4.prev = 1;
          _context4.next = 4;
          return request({
            url: 'api/base/csBaseResources/fetch-floor',
            method: 'get',
            params: params
          });
        case 4:
          data = _context4.sent;
          return _context4.abrupt("return", (data || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              value: item.floorId,
              label: item.floorName
            });
          }));
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](1);
          return _context4.abrupt("return", []);
        case 11:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 8]]);
  }));
  return _loadFloorDict.apply(this, arguments);
}
export function loadRoomDict() {
  return _loadRoomDict.apply(this, arguments);
}

/**
 * 获取道路字典列表
 *
 * @param params {Object<{ areaId: string, roadName: string }>}
 */
function _loadRoomDict() {
  _loadRoomDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var params,
      data,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          params = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _context5.prev = 1;
          _context5.next = 4;
          return request({
            url: 'api/base/csBaseResources/fetch-room',
            method: 'get',
            params: params
          });
        case 4:
          data = _context5.sent;
          return _context5.abrupt("return", (data || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              value: item.roomId,
              label: item.roomName
            });
          }));
        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](1);
          return _context5.abrupt("return", []);
        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 8]]);
  }));
  return _loadRoomDict.apply(this, arguments);
}
export function loadRoadDict() {
  return _loadRoadDict.apply(this, arguments);
}

/**
 * 获取资源树
 *
 * @param params {Object<{ resourcesTypeList: number[] }>}
 * @return {Promise<Array>}
 */
function _loadRoadDict() {
  _loadRoadDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var params,
      data,
      _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          params = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _context6.prev = 1;
          _context6.next = 4;
          return request({
            url: 'api/base/csBaseResources/fetch-road',
            method: 'get',
            params: params
          });
        case 4:
          data = _context6.sent;
          return _context6.abrupt("return", (data || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              value: item.roadId,
              label: item.roadName
            });
          }));
        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](1);
          return _context6.abrupt("return", []);
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[1, 8]]);
  }));
  return _loadRoadDict.apply(this, arguments);
}
export function loadResourceTree() {
  return _loadResourceTree.apply(this, arguments);
}
function _loadResourceTree() {
  _loadResourceTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var params,
      data,
      _args7 = arguments;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          params = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _context7.prev = 1;
          _context7.next = 4;
          return request({
            url: 'api/base/csBaseResources/query-resources-tree',
            method: 'post',
            data: params
          });
        case 4:
          data = _context7.sent;
          return _context7.abrupt("return", data || []);
        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](1);
          return _context7.abrupt("return", []);
        case 11:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[1, 8]]);
  }));
  return _loadResourceTree.apply(this, arguments);
}
export default {
  addArea: addArea,
  add: add,
  edit: edit,
  del: del,
  detail: detail,
  switchStatus: switchStatus,
  uploadRoom: uploadRoom,
  loadAreaDict: loadAreaDict,
  loadBuildingDict: loadBuildingDict,
  loadFloorDict: loadFloorDict,
  loadRoomDict: loadRoomDict,
  loadRoadDict: loadRoadDict,
  loadResourceTree: loadResourceTree
};